<template>
    <div class="f2g-wind-container">
        <div class="modal-force" v-show="showModal">
            <div class="modal-overlay-force" @click="closeModal"></div>
            <div class="modal-container-force">
                <div class="modal-header-force">
                    <h3>{{ title }}</h3>
                    <button class="modal-close-force" @click="closeModal">
                        <i class="fa-force fa-times-force"></i>
                    </button>
                </div>
                <div class="modal-body-force">
                    <slot></slot>
                </div>
                <div class="modal-footer-force">
                    <button class="modal-btn-force" @click="closeModal">{{ closeBtnText }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "WarningModal",
    data: function () {
        return { 
            show: true, 
        }
    },
    computed: {
        getLocale() {
            var locale;
            if ($("body").data("locale") == "el_GR") {
                locale = "el";
            } else {
                locale = "en";
            }
            return locale;
        },
        title() {
            return this.$store.state.forcePersonalDataMessage;
        },
        showWarningModal() {
            return this.$store.state.showWarningModal;
        },
        closeBtnText() {
            if(this.getLocale == "el")
                return "Κλείσιμο";
            else
                return "Close";
        },
        showModal(){
            return this.show;
        }
    },
    methods: {
        closeModal() {
            this.show=false;
        }
    }
}
</script>
<style scoped>
.modal-force {
    background: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    overflow-y: auto;
}

.modal-overlay-force {
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.modal-container-force {
    background: #fff;
    width: 80%;
    max-width: 800px;
    max-height: 90vh;
    overflow: auto;
    border-radius: 10px;
    padding: 20px;
}

.modal-header-force {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.modal-close-force {
    border: none;
    background: none;
    cursor: pointer;
    padding: 0;
    font-size: 1.2rem;
    color: #333;
    margin-left: 20px;
}

.modal-body-force {
    margin-bottom: 20px;
}

.modal-footer-force {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.modal-btn-force {
    border: none;
    background: #428bca;
    color: #fff;
    cursor: pointer;
    padding: 10px 20px;
    border-radius: 5px;
    margin-left: 20px;
}

.modal-btn-force:hover {
    background: #3071a9;
}

.modal-btn-force:focus {
    outline: none;
}

@media screen and (max-width: 600px) {
    .modal-container-force {
        width: 90%;
        max-height: 80vh;
    }
}

@media screen and (max-height: 500px) {
    .modal-container-force {
        max-height: 70vh;
    }
}
</style>
